import React from 'react'
import PropTypes from 'prop-types'

import { ModifierGroup } from '../ModifierGroup/ModifierGroup'
import { MenuItem } from '../MenuItem/MenuItem'

import { SpecialInstructions } from '../SpecialInstructions/SpecialInstructions'

import { maxCharacters } from '../modifier-form-helpers'

export const ModifierBody = ({
  values,
  specialRequestsConfig,
  itemDetails,
  deleteButton,
  quantityInputField
}) => (
  <React.Fragment>
    <MenuItem
      calories={itemDetails.calories}
      description={itemDetails.description}
      imageUrl={itemDetails.imageUrl}
    />
    {itemDetails.modifierGroups.map(modifier => (
      <ModifierGroup
        key={modifier.guid}
        values={values}
        modifierGroup={modifier}
      />
    ))}
    {specialRequestsConfig.enabled && (
      <SpecialInstructions
        label='Special Instructions'
        name='specialInstructions'
        maxLength={maxCharacters}
        rows={4}
        placeholder={specialRequestsConfig.placeholderMessage}
      />
    )}
    {quantityInputField}
    {deleteButton}
  </React.Fragment>
)

const specialRequestsConfigShape = PropTypes.shape({
  enabled: PropTypes.bool,
  placeholderMessage: PropTypes.string
})

const itemDetailsShape = PropTypes.shape({
  modifierGroups: PropTypes.array.isRequired,
  calories: PropTypes.number,
  description: PropTypes.string,
  imageUrl: PropTypes.string
})

ModifierBody.propTypes = {
  deleteButton: PropTypes.node,
  values: PropTypes.object.isRequired,
  specialRequestsConfig: specialRequestsConfigShape.isRequired,
  itemDetails: itemDetailsShape,
  quantityInputField: PropTypes.node.isRequired
}
